import { render, staticRenderFns } from "./CheckBoxGroup.vue?vue&type=template&id=0154ae31&scoped=true"
import script from "./CheckBoxGroup.vue?vue&type=script&lang=ts"
export * from "./CheckBoxGroup.vue?vue&type=script&lang=ts"
import style0 from "./CheckBoxGroup.vue?vue&type=style&index=0&id=0154ae31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0154ae31",
  null
  
)

export default component.exports